var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-ueditor-wrap',{ref:"editor",attrs:{"config":_vm.myConfig},model:{value:(_vm.msg),callback:function ($$v) {_vm.msg=$$v},expression:"msg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }